<template>
  <div class="reserve-parking text-center">
    <v-menu
      bottom
      offset-y
      left
      min-width="50%"
      max-width="50%"
      :disabled="reserveTime != null"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-fab-transition>
          <v-btn
            large
            v-bind="attrs"
            v-on="on"
            fab
            fixed
            right
            bottom
            color="primary-base"
            class="reserve-parking-cta mb-1 elevation-0"
            :class="reserveTime ? 'reserve-time-selected' : ''"
            :loading="loading"
          >
            <div class="reserve-parking-timer" style="position: relative;">
              <v-icon medium color="primary">$bell</v-icon>
              <div
                class="reserve-selected d-flex  rounded-pill"
                v-if="reserveTime"
              >
                <small class="w-100 ma-auto">{{
                  reserveTime.split(" ")[0]
                }}</small>
                <!-- <small>{{ reserveTime.split(" ")[1] }}</small> -->
              </div>
            </div>
            <!-- <span class="reserve-parking-label"> Arrivo tra <br /> </span> -->
          </v-btn>
        </v-fab-transition>
      </template>
      <v-list class="reserve-parking-list">
        <v-list-item v-for="(item, index) in minutes" :key="index">
          <v-list-item-title @click="setReserveTime(item.value)">
            <span class="font-weight-bold">{{ item.value }}</span>
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>
<style lang="scss">
.reserve-parking-list {
  .v-list-item:not(:last-child) {
    border-bottom: 1px solid var(--v-grey-darken2) !important;
  }
}
.reserve-parking {
  &-cta {
    bottom: 190px !important;
    padding: 25px;
    right: 2%;
    background-color: var(--v-secondary-base) !important;
    color: $primary !important;
    border-radius: 0px !important;
    .description {
      display: inline;
    }
    .v-btn__content {
      flex-direction: column;
      display: flex;
      white-space: nowrap;
    }
    .reserve-parking-label {
      font-size: 9px;
      margin-top: 2px !important;
    }
  }
  &-list {
    background-color: var(--v-secondary-base) !important;
  }
  .reserve-parking-timer {
    position: relative;
    //min-width: 10px;
    // max-width: fit-content;
  }
}
.reserve-parking-container {
  position: relative;
}

.reserve-time-selected {
  background-color: #ffc400 !important;
  pointer-events: none;
  cursor: pointer;
  &.disabled {
    background-color: #ffc400 !important;
  }
}
.reserve-selected {
  background-color: var(--v-primary-base);
  position: absolute;
  top: -8px;
  right: -5px;
  width: 20px;
  height: 20px;

  small {
    color: #ffffff;
  }
}
</style>
<script>
import { mapGetters } from "vuex";
//import OrderService from "~/service/orderService";
import eurospinCustomService from "@/service/eurospinCustomService";
//import orderService from "@/commons/service/orderService";
export default {
  data() {
    return {
      reserveTime: null,
      loading: false,
      minutes: Object.values(this.$t("order.easydriveHours")),
      dialog: false,
      error: null,
      message: null
    };
  },
  props: {
    hasReserveButton: { type: Boolean, default: false },
    order: { type: Object, required: true }
  },
  components: {},
  computed: {
    ...mapGetters({
      isAuthenticated: "cart/isAuthenticated"
    })
    // minutesTranslated() {
    //   // eslint-disable-next-line no-unused-vars
    //   const locale = this.$i18n.locale;
    //   return this.minutes.map(item => ({
    //     value: item.value,
    //     text: this.$t(item.text) // 'item.text' is a translation key from your JSON.
    //   }));
    // }
  },
  methods: {
    async setReserveTime(value) {
      const urlParams = new URLSearchParams(window.location.search);
      const token = urlParams.get("access_token");
      this.loading = true;
      if (value) {
        this.reserveTime = value;
      }
      try {
        let result = null;
        if (this.isAuthenticated) {
          result = await eurospinCustomService.reservationParking(
            this.order,
            0,
            this.reserveTime
          );
        } else {
          result = await eurospinCustomService.reserveParking(
            this.order,
            0,
            this.reserveTime,
            token
          );
        }
        if (result) {
          this.loading = false;
          if (!result.success) {
            this.reserveTime = null;
          }
        }
      } catch (err) {
        this.error = err.message;
        this.loading = false;
        this.reserveTime = null;
      } finally {
        this.loading = false;
      }
    },
    getReserveTime() {
      this.reserveTime = this.order?.orderInfos?.reservation_info?.split(
        ","
      )[0];
      // this.reserveTime = 60;
    }
  },
  mounted() {
    this.getReserveTime();
  }
};
</script>
